export default "__VITE_ASSET__FOuZ8gF1__"